import mdlCommune from '@/models/General/GCommune'
import GCoreBusinessSii from '../../../models/General/GCoreBusinessSii'
import GCompany from '../../../models/General/GCompany'
import PostCustomerCreditOptions from '../../../models/POS/PosCustomerCreditOption'
import PchPaymentCondition from '../../../models/Purchase/PchPaymentCondition'

const setHtmlPrint = ({ commit }, bool) => {
    localStorage.setItem('html-print', bool)
    commit('SET_HTML_PPRINT', bool)
}

const initCompanyData = async ({ state, dispatch, rootGetters }) => {
    if (state.companyData) return
    if (localStorage.getItem('company-data'))
        dispatch(
            'setCompanyData',
            JSON.parse(localStorage.getItem('company-data'))
        )
    if (!rootGetters['AuthModule/isAuthenticated']) {
        setTimeout(() => dispatch('initCompanyData'), 200)
        return
    } else {
        new GCompany()
            .first()
            .then(r => {
                localStorage.setItem('company-data', JSON.stringify(r))
                dispatch('setCompanyData', r)
            })
            .catch(console.log)
    }
}

const setCompanyData = ({ commit }, data) => commit('SET_COMPANY_DATA', data)

const initCommunes = async ({ commit, rootState }) => {
    if (!rootState.AuthModule.token) {
        setTimeout(initCommunes({ commit, rootState }), 200)
        return
    }
    let communes = await mdlCommune.params({ get_all_results: true }).get()
    commit('SET_COMMUNES', communes.data)
}

const initCoreBusinessList = async ({ commit, rootState }) => {
    if (!rootState.AuthModule.token) {
        setTimeout(initCoreBusinessList({ commit, rootState }), 200)
        return
    }
    let coreBusinessList = await new GCoreBusinessSii().limit(-1).get()
    commit('SET_CORE_BUSINESS_LIST', coreBusinessList.data)
}

const setCustomerCreditOptions = ({ commit }, options) =>
    commit('SET_CUSTOMER_CREDIT_OPTIONS', options)

const fetchCustomerCreditOptions = ({ dispatch }) =>
    dispatch('setCustomerCreditOptions', [
        { id: 0, credit_option: '15 días', days: 15 },
        { id: 1, credit_option: '30 días', days: 30 },
        { id: 2, credit_option: '60 días', days: 60 },
        { id: 3, credit_option: '90 días', days: 90 },
        { id: 4, credit_option: 'Contra Entrega', days: 1 },
        { id: 5, credit_option: '5 días', days: 5 },
        { id: 6, credit_option: '7 días', days: 7 },
        { id: 7, credit_option: '10 días', days: 10 },
    ])
// new PostCustomerCreditOptions()
//     .include('days')
//     .get()
//     .then(r => dispatch('setCustomerCreditOptions', r.data))
//     .catch(console.log)

const setPchPaymentConditions = ({ commit }, array) =>
    commit('SET_PCH_PAYMENT_CONDITIONS', array)

const fetchPchPaymentConditions = ({ dispatch }) =>
    dispatch('setPchPaymentConditions', [
        { id: 6, type: '5 días', days: 5 },
        { id: 9, type: '7 días', days: 7 },
        { id: 10, type: '10 días', days: 10 },
        { id: 7, type: '15 días', days: 15 },
        { id: 1, type: '30 días', days: 30 },
        { id: 2, type: '45 días', days: 45 },
        { id: 3, type: '60 días', days: 60 },
        { id: 4, type: '90 días', days: 90 },
        { id: 5, type: 'Anticipado', days: 0 },
        { id: 8, type: 'Contra Entrega', days: 1 },
    ])
// new PchPaymentCondition()
//     .include('days')
//     .get()
//     .then(r => dispatch('setPchPaymentConditions', r.data))
//     .catch(console.log)

const setMobileSelectedPaymentMethod = ({ commit }, id) =>
    commit('SET_MOBILE_SELECTED_PAYMENT_METHOD', id)

const setMobileCommentary = ({ commit }, string) =>
    commit('SET_MOBILE_COMMENTARY', string)

const setMobileIsQuotation = ({ commit }, bool) =>
    commit('SET_MOBILE_IS_QUOTATION', bool)

const setMobileStorePickup = ({ commit }, bool) =>
    commit('SET_MOBILE_STORE_PICKUP', bool)

const setMobileExpirationDate = ({ commit }, number) =>
    commit('SET_MOBILE_EXPIRATION_DATE', number)

const setMobileCustomerEmail = ({ commit }, string) =>
    commit('SET_MOBILE_CUSTOMER_EMAIL', string)

const clearMobileData = ({ commit }) => commit('CLEAR_MOBILE_DATA')

// const setMobileSelectedPaymentMethod = ({ commit }, id) =>
//     commit('SET_MOBILE_SELECTED_PAYMENT_METHOD', id)

// const setMobileCommentary = ({ commit }, string) =>
//     commit('SET_MOBILE_COMMENTARY', string)

// const setMobileIsQuotation = ({ commit }, bool) =>
//     commit('SET_MOBILE_IS_QUOTATION', bool)

// const setMobileStorePickup = ({ commit }, bool) =>
//     commit('SET_MOBILE_STORE_PICKUP', bool)

// const setMobileExpirationDate = ({ commit }, number) =>
//     commit('SET_MOBILE_EXPIRATION_DATE', number)

// const setMobileCustomerEmail = ({ commit }, string) =>
//     commit('SET_MOBILE_CUSTOMER_EMAIL', string)

// const clearMobileData = ({ commit }) => commit('CLEAR_MOBILE_DATA')

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

export default {
    resetState,
    initCommunes,
    initCoreBusinessList,
    initCompanyData,
    setCompanyData,
    setHtmlPrint,
    setCustomerCreditOptions,
    fetchCustomerCreditOptions,
    setPchPaymentConditions,
    fetchPchPaymentConditions,
    setMobileSelectedPaymentMethod,
    setMobileCommentary,
    setMobileIsQuotation,
    setMobileExpirationDate,
    setMobileStorePickup,
    setMobileCustomerEmail,
    clearMobileData,
}
